interface LabelOffIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const LabelOffIcon = ({ width = 116, height = 116, className }: LabelOffIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <g clipPath="url(#clip0_2365_88619)">
        <g filter="url(#filter0_dd_2365_88619)">
          <path
            d="M53.9752 10.4136C56.4527 8.92785 59.5473 8.92785 62.0248 10.4136L70.0534 15.228C71.0691 15.8371 72.2097 16.2077 73.3893 16.3119L82.7144 17.136C85.5921 17.3903 88.0957 19.2093 89.2268 21.8675L92.8922 30.4816C93.3558 31.5713 94.0608 32.5415 94.9539 33.3193L102.014 39.4671C104.192 41.3643 105.149 44.3074 104.501 47.1228L102.403 56.2462C102.138 57.4003 102.138 58.5997 102.403 59.7538L104.501 68.8772C105.149 71.6926 104.192 74.6357 102.014 76.5329L94.9539 82.6807C94.0608 83.4585 93.3558 84.4287 92.8922 85.5184L89.2268 94.1325C88.0957 96.7907 85.5921 98.6097 82.7144 98.864L73.3893 99.6881C72.2097 99.7923 71.069 100.163 70.0534 100.772L62.0248 105.586C59.5473 107.072 56.4527 107.072 53.9752 105.586L45.9466 100.772C44.931 100.163 43.7903 99.7923 42.6107 99.6881L33.2856 98.864C30.4079 98.6097 27.9043 96.7907 26.7732 94.1325L23.1078 85.5184C22.6442 84.4287 21.9392 83.4585 21.0461 82.6807L13.9864 76.5329C11.8077 74.6357 10.8515 71.6926 11.4989 68.8772L13.5967 59.7538C13.8621 58.5997 13.8621 57.4003 13.5967 56.2462L11.4989 47.1228C10.8515 44.3074 11.8077 41.3643 13.9864 39.4671L21.0461 33.3193C21.9392 32.5415 22.6442 31.5713 23.1078 30.4816L26.7732 21.8675C27.9043 19.2093 30.4079 17.3903 33.2856 17.136L42.6107 16.3119C43.7903 16.2077 44.9309 15.8371 45.9466 15.228L53.9752 10.4136Z"
            fill="#EC4143"
          />
          <path
            d="M54.4893 11.2715C56.6502 9.97561 59.3498 9.97561 61.5107 11.2715L69.5391 16.0859C70.6845 16.7728 71.9714 17.19 73.3018 17.3076L82.626 18.1318C85.1359 18.3536 87.32 19.9403 88.3066 22.2588L91.9717 30.873C92.4946 32.1019 93.2898 33.1962 94.2969 34.0732L101.356 40.2217C103.257 41.8764 104.091 44.4428 103.526 46.8984L101.429 56.0225C101.13 57.3239 101.13 58.6761 101.429 59.9775L103.526 69.1016C104.091 71.5572 103.257 74.1236 101.356 75.7783L94.2969 81.9268C93.2898 82.8038 92.4946 83.8981 91.9717 85.127L88.3066 93.7412C87.32 96.0597 85.1359 97.6464 82.626 97.8682L73.3018 98.6924C71.9714 98.81 70.6845 99.2272 69.5391 99.9141L61.5107 104.729C59.3498 106.024 56.6502 106.024 54.4893 104.729L46.4609 99.9141C45.3155 99.2272 44.0286 98.81 42.6982 98.6924L33.374 97.8682C30.8641 97.6464 28.68 96.0597 27.6934 93.7412L24.0283 85.127C23.5054 83.8981 22.7102 82.8038 21.7031 81.9268L14.6436 75.7783C12.7434 74.1236 11.9091 71.5572 12.4736 69.1016L14.5713 59.9775C14.8705 58.6761 14.8705 57.3239 14.5713 56.0225L12.4736 46.8984C11.9091 44.4428 12.7434 41.8764 14.6436 40.2217L21.7031 34.0732C22.7102 33.1962 23.5054 32.1019 24.0283 30.873L27.6934 22.2588C28.68 19.9403 30.8641 18.3536 33.374 18.1318L42.6982 17.3076C44.0286 17.19 45.3155 16.7728 46.4609 16.0859L54.4893 11.2715Z"
            stroke="white"
            strokeWidth="2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_2365_88619"
          x="-8.70044"
          y="-2.70072"
          width="133.401"
          height="137.401"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2365_88619" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_2365_88619" result="effect2_dropShadow_2365_88619" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2365_88619" result="shape" />
        </filter>
        <clipPath id="clip0_2365_88619">
          <rect width="116" height="116" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LabelOffIcon;
